// extracted by mini-css-extract-plugin
export default {"delete":"PPCard_delete__3IT3h","deleteMoveUp":"PPCard_deleteMoveUp__l3kom","details":"PPCard_details__HOuU4","active":"PPCard_active__EwP6+"};